import { createContext } from 'react'
import { OptionsType } from '@ors/components/manage/Blocks/ProjectsListing/interfaces'
import { Cluster, Country } from '@ors/types/store'
import { ProjectTypeType } from '@ors/types/api_project_types'
import { ProjectSectorType } from '@ors/types/api_project_sector'
import { ProjectSubSectorType } from '@ors/types/api_project_subsector'
import { ApiSubstance } from '@ors/types/api_substances'
import { ApiBlend } from '@ors/types/api_blends'
import { ApiAgency } from '@ors/types/api_agencies'

interface ProjectsDataContextProps {
  countries: Country[]
  agencies: ApiAgency[]
  clusters: Cluster[]
  project_types: ProjectTypeType[]
  sectors: ProjectSectorType[]
  subsectors: ProjectSubSectorType[]
  substances: ApiSubstance[]
  blends: ApiBlend[]
  fileTypes: string[]
  consumptionLevelStatuses: OptionsType[]
  altTechs: OptionsType[]
}

const ProjectsDataContext = createContext<ProjectsDataContextProps>(
  null as unknown as ProjectsDataContextProps,
)

export default ProjectsDataContext
